/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import BannerSettingsRepository from '../../repositories/Admin/BannerSettingsRepository';
import { createRestSlice } from '../../utils/RestSlice';

const bannerSettingsRestSlice = createRestSlice({
  resource: 'bannerSetting',
  repository: BannerSettingsRepository,
  slices: ['loadBannerSettings', 'updateBannerSetting'],
});

const initialState = {
  ...bannerSettingsRestSlice.initialState,
};

const bannerSettingsSlice = createSlice({
  name: 'bannerSettings',
  initialState,
  reducers: {
    ...bannerSettingsRestSlice.reducers,
  },
});

export default bannerSettingsSlice.reducer;

export const bannerSettingsRestHooks = bannerSettingsRestSlice.hooks(
  bannerSettingsSlice,
  ['admin', 'BannerSettingsSlice']
);
